// @ts-nocheck
import React from 'react';
import { Formik, FieldArray } from 'formik';
import {
    Button,
    Text,
    Modal,
    ModalHeader,
    ModalContent,
    Cross,
    Form,
    Icon,
    Space,
    Conditional,
    Popup,
    InputWithAction,
} from '@cashfree-intl/coherent';

import {
    StyledFormButtonWrapper,
    StyledFormWrapper,
    StyledInputWithAction,
    StyledSlabCtaWrapper,
    StyledTDRSlabFormWrapper,
    StyledTwoColumnRow,
    StyledDropdown,
} from './styled';
import CustomIcons from 'components/CustomIcons';
import { CURRENCY_SYMBOL } from 'utils/constants';
import { CONDITION_DROPDOWN_OPTIONS, IN_BETWEEN } from '../constants';
import { InitialFormValues, ExternalPMRFormProps } from '../types';
import { validationSchema } from './validation';

const getInitialFormValue = (data: any = {}) => ({
    externalUpfrontTdr: data.externalUpfrontTdr || '',
    greaterThanValue: data.greaterThanValue || '',
    lessThanEqualsToValue: data.lessThanEqualsToValue || '',
    ceil: data.ceil || '',
    floor: data.floor || '',
    fixedFee: data.fixedFee || '',
    condition: IN_BETWEEN,
});

const ExternalPMRForm = ({ initialValues, closeModal, onSubmit }: ExternalPMRFormProps) => {

    const isEditMode = Object.keys(initialValues).length > 0;

    const initialFormValues: InitialFormValues = {
        externalPMR: [{ ...getInitialFormValue(initialValues) }],
    };

    return (
        <Modal open $maxWidth={536}>
            <ModalHeader>
                Create TDR Slab <Cross onClick={closeModal} />
            </ModalHeader>
            <ModalContent className="p-0">
                <Formik
                    initialValues={initialFormValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting }) => {
                        return (
                            <Form onSubmit={handleSubmit}>
                                <StyledFormWrapper>
                                    <FieldArray
                                        name="externalPMR"
                                        render={({ remove, push }) => (
                                            <>
                                                {values.externalPMR.map((obj, index) => {
                                                    let amountConditionError;
                                                    let tdrOrFixedFeeError;

                                                    if (touched.externalPMR && errors.externalPMR) {
                                                        if ((touched.externalPMR[index]?.greaterThanValue ||
                                                            touched?.externalPMR[index]?.lessThanEqualsToValue) &&
                                                            errors.externalPMR) {
                                                            amountConditionError = Array.isArray(errors.externalPMR) &&
                                                                errors.externalPMR[index]?.greaterThanValue || errors.externalPMR[index]?.lessThanEqualsToValue;
                                                        }
                                                        if ((touched.externalPMR[index]?.externalUpfrontTdr ||
                                                            touched?.externalPMR[index]?.fixedFee) &&
                                                            errors.externalPMR) {
                                                            tdrOrFixedFeeError = Array.isArray(errors.externalPMR) &&
                                                                errors.externalPMR[index]?.externalUpfrontTdr || errors.externalPMR[index]?.fixedFee;
                                                        }
                                                    }

                                                    return (
                                                        <StyledTDRSlabFormWrapper key={index}>
                                                            <Conditional if={index > 0}>
                                                                <hr className='mb-2' />
                                                            </Conditional>
                                                            <Space alignItems="end" className="mb-2" gap={3}>
                                                                <Text>
                                                                    Slab {index + 1}
                                                                </Text>
                                                                <Conditional if={!initialValues || Object.keys(initialValues).length === 0}>
                                                                    <StyledSlabCtaWrapper alignItems="end" justifyContent="space-between" gap={2}>
                                                                        <Popup
                                                                            content="Add another slab"
                                                                            trigger={
                                                                                <CustomIcons
                                                                                    className="pointer rounded-add"
                                                                                    componentName="ROUNDED_ADD"
                                                                                    onClick={() => push({ ...getInitialFormValue({}) })}
                                                                                    data-event-name="Form_AddTDRSlab_Add_Another_Slab"
                                                                                    data-ignore-inner-text="true"
                                                                                />
                                                                            }
                                                                            position="top center"
                                                                        />
                                                                        <Conditional if={index > 0}>
                                                                            <Popup
                                                                                content="Add another rule"
                                                                                trigger={
                                                                                    <span
                                                                                        className='pointer'
                                                                                        data-event-name="Form_AddTDRSlab_Delete_Slab"
                                                                                        data-ignore-inner-text="true"
                                                                                        onClick={() => remove(index)}
                                                                                    >
                                                                                        <Icon name="delete" />
                                                                                    </span>
                                                                                }
                                                                                position="top center"
                                                                            />
                                                                        </Conditional>
                                                                    </StyledSlabCtaWrapper>
                                                                </Conditional>
                                                            </Space>
                                                            <div>
                                                                <div className="mb-3">
                                                                    <Text variant="b12" color="bodyLight" className="mb-1">
                                                                        Condition
                                                                    </Text>
                                                                    <StyledDropdown
                                                                        id={`condition-${index}`}
                                                                        name={`externalPMR[${index}].condition`}
                                                                        value={obj.condition}
                                                                        errors={errors}
                                                                        disabled={isSubmitting || isEditMode}
                                                                        touched={touched}
                                                                        onChange={(e, { value }) => setFieldValue(`externalPMR[${index}].condition`, value)}
                                                                        onBlur={handleBlur}
                                                                        placeholder="Select a condition"
                                                                        options={CONDITION_DROPDOWN_OPTIONS}
                                                                        selection
                                                                        icon="chevron down"
                                                                    />
                                                                </div>
                                                                {/* We can keep a row for two inputs */}
                                                                <div className="mb-3">
                                                                    <StyledTwoColumnRow className="amount-condition-fields" alignItems="center" gap={3}>
                                                                        <Conditional if={obj.condition !== 'LESS_THAN_EQUALS_TO'}>
                                                                            <StyledInputWithAction>
                                                                                <InputWithAction
                                                                                    inputLabel="Greater than"
                                                                                    id={`greaterThanValue-${index}`}
                                                                                    name={`externalPMR[${index}].greaterThanValue`}
                                                                                    type="number"
                                                                                    disabled={isSubmitting || isEditMode}
                                                                                    label={CURRENCY_SYMBOL.INR}
                                                                                    value={obj.greaterThanValue}
                                                                                    errors={errors.externalPMR?.[index]}
                                                                                    touched={touched.externalPMR?.[index]}
                                                                                    placeholder="Amount greater than"
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                />
                                                                            </StyledInputWithAction>
                                                                        </Conditional>
                                                                        <Conditional if={obj.condition !== 'GREATER_THAN'}>
                                                                            <StyledInputWithAction>
                                                                                <InputWithAction
                                                                                    inputLabel="Less than equals to"
                                                                                    id={`lessThanEqualsToValue-${index}`}
                                                                                    name={`externalPMR[${index}].lessThanEqualsToValue`}
                                                                                    type="number"
                                                                                    disabled={isSubmitting || isEditMode}
                                                                                    label={CURRENCY_SYMBOL.INR}
                                                                                    value={obj.lessThanEqualsToValue}
                                                                                    errors={errors.externalPMR?.[index]}
                                                                                    touched={touched.externalPMR?.[index]}
                                                                                    placeholder="Amount less than equals to"
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                />
                                                                            </StyledInputWithAction>
                                                                        </Conditional>
                                                                    </StyledTwoColumnRow>
                                                                    <Text variant="b12" color="danger" className="mt-1">
                                                                        {amountConditionError}
                                                                    </Text>
                                                                </div>
                                                                <div className='mb-3'>
                                                                    <StyledInputWithAction>
                                                                        <InputWithAction
                                                                            inputLabel="Floor"
                                                                            id={`floor-${index}`}
                                                                            name={`externalPMR[${index}].floor`}
                                                                            type="number"
                                                                            disabled={isSubmitting}
                                                                            label={CURRENCY_SYMBOL.INR}
                                                                            value={obj.floor}
                                                                            errors={errors.externalPMR?.[index]}
                                                                            touched={touched.externalPMR?.[index]}
                                                                            placeholder="Enter Floor Value"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                    </StyledInputWithAction>
                                                                    <Text variant="b12" color="danger" className="mt-1">
                                                                        {errors.externalPMR?.[index].floor}
                                                                    </Text>
                                                                </div>
                                                                <div className="mb-3">
                                                                    <StyledTwoColumnRow alignItems="center" gap={3}>
                                                                        <StyledInputWithAction>
                                                                            <InputWithAction
                                                                                inputLabel="TDR Percentage"
                                                                                id={`externalUpfrontTdr-${index}`}
                                                                                name={`externalPMR[${index}].externalUpfrontTdr`}
                                                                                type="number"
                                                                                label='%'
                                                                                disabled={isSubmitting}
                                                                                value={obj.externalUpfrontTdr}
                                                                                errors={errors.externalPMR?.[index]}
                                                                                touched={touched.externalPMR?.[index]}
                                                                                placeholder="Enter TDR Value"
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                        </StyledInputWithAction>
                                                                        <StyledInputWithAction>
                                                                            <InputWithAction
                                                                                inputLabel="Fixed Fee"
                                                                                id={`fixedFee-${index}`}
                                                                                name={`externalPMR[${index}].fixedFee`}
                                                                                type="number"
                                                                                disabled={isSubmitting}
                                                                                label={CURRENCY_SYMBOL.INR}
                                                                                value={obj.fixedFee}
                                                                                errors={errors.externalPMR?.[index]}
                                                                                touched={touched.externalPMR?.[index]}
                                                                                placeholder="Enter Fixed Fee Value"
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                        </StyledInputWithAction>
                                                                    </StyledTwoColumnRow>
                                                                    <Text variant="b12" color="danger" className="mt-1">
                                                                        {tdrOrFixedFeeError}
                                                                    </Text>
                                                                </div>
                                                                <div className='mb-3'>
                                                                    <StyledInputWithAction>
                                                                        <InputWithAction
                                                                            inputLabel="Ceil"
                                                                            id={`ceil-${index}`}
                                                                            name={`externalPMR[${index}].ceil`}
                                                                            type="number"
                                                                            disabled={isSubmitting}
                                                                            label={CURRENCY_SYMBOL.INR}
                                                                            value={obj.ceil}
                                                                            errors={errors.externalPMR?.[index]}
                                                                            touched={touched.externalPMR?.[index]}
                                                                            placeholder="Enter Ceil Value"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                        />
                                                                    </StyledInputWithAction>
                                                                    <Text variant="b12" color="danger" className="mt-1">
                                                                        {errors.externalPMR?.[index].ceil}
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                        </StyledTDRSlabFormWrapper>
                                                    )
                                                })}
                                            </>
                                        )}
                                    />
                                </StyledFormWrapper>
                                <StyledFormButtonWrapper alignItems="center" justifyContent="end">
                                    <Button link className="p-0" onClick={closeModal} disabled={isSubmitting}>
                                        Cancel
                                    </Button>
                                    <Button type="submit" primary loading={isSubmitting}>
                                        Submit
                                    </Button>
                                </StyledFormButtonWrapper>
                            </Form>
                        );
                    }}
                </Formik>
            </ModalContent>
        </Modal>
    );
};

export default ExternalPMRForm;
